import { IPrismicRedirection } from './types';

export const mapRedirectionHandler = ({
  prismicContent,
}): IPrismicRedirection => {
  const { items, primary, slice_type, slice_group_uid }: IPrismicRedirection =
    prismicContent;

  return {
    items,
    primary,
    slice_type,
    slice_group_uid,
  };
};
